import { ButtonProps } from '../../atoms/Button';
import { DividerProps } from '../../atoms/Divider';
import { TextProps } from '../../atoms/Text';
import { TabsListProps } from '../TabsList';


type MyAccountHeaderInternalProps = {
  text?: TextProps;
  button?: ButtonProps;
  tabsList?: TabsListProps;
  divider?: DividerProps;
};

type MyAccountHeaderPropsValues = {
  '': MyAccountHeaderInternalProps;
};

const propValues: MyAccountHeaderPropsValues = {
  '': {
    text: {
      style: 'Bold',
      align: 'Left',
      colour: 'Default',
      type: 'Heading1',
    },
    button: {
      style: 'Text',
      size: 'Small',
      type: 'TextIcon',
      colour: 'PrimaryAction',
      loading: 'Default',
    },
    tabsList: {
    },
    divider: {
      type: 'Horizontal',
      style: 'Solid',
      colour: 'BorderBase',
    },
  },
};

const getProps = (type: string): MyAccountHeaderInternalProps => {
  const values: MyAccountHeaderInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
